
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXJldGFpbj4 from './androidx-compose-runtime-runtime-retain.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg from './androidx-compose-runtime-runtime-saveable.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZS1jb21wb3NlPg from './androidx-lifecycle-lifecycle-runtime-compose.mjs';
import * as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsLWNvbXBvc2U_ from './androidx-lifecycle-lifecycle-viewmodel-compose.mjs';
import * as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsPg from './androidx-lifecycle-lifecycle-viewmodel.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXJldGFpbj4__ALL_EXPORTS } from './androidx-compose-runtime-runtime-retain.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime-saveable.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZS1jb21wb3NlPg__ALL_EXPORTS } from './androidx-lifecycle-lifecycle-runtime-compose.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsLWNvbXBvc2U___ALL_EXPORTS } from './androidx-lifecycle-lifecycle-viewmodel-compose.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsPg__ALL_EXPORTS } from './androidx-lifecycle-lifecycle-viewmodel.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime-saveable>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXNhdmVhYmxlPg__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime-retain>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lLXJldGFpbj4__ALL_EXPORTS,
    '<androidx.lifecycle:lifecycle-viewmodel>': PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsPg__ALL_EXPORTS,
    '<androidx.lifecycle:lifecycle-viewmodel-compose>': PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtdmlld21vZGVsLWNvbXBvc2U___ALL_EXPORTS,
    '<androidx.lifecycle:lifecycle-runtime-compose>': PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZS1jb21wb3NlPg__ALL_EXPORTS,
};
    